import React from 'react';
import ReactPlayer from 'react-player';
import Modal from '../../modal/modal';

export default class ZoomedVideoModal extends React.Component {

    render() {
        const { videoUrl, ...rest } = this.props;
        const contentStyle = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        };

        return (
            <Modal show {...rest} contentStyle={contentStyle}>
                <div className='modal-content-wrapper'>
                    <button className='modal-exit-btn' onClick={rest.onClose}>x</button>
                    <div className='zoomed-video'>
                        <ReactPlayer
                            url={videoUrl} playing controls
                            width='100%' height='100%'
                        />
                    </div>
                </div>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/section/components/video-modal.js